import {
    UPDATE_CHECK_IN_SETTINGS_STARTED,
    UPDATE_CHECK_IN_SETTINGS_SUCCESS,
    UPDATE_CHECK_IN_SETTINGS_FAILURE,
    GET_CHECK_IN_SETTINGS_STARTED,
    GET_CHECK_IN_SETTINGS_SUCCESS,
    GET_CHECK_IN_SETTINGS_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/check-in-settings/checkInSettings"

const initialState = {
    settings: null,
    loading: false,
    error: null,
    message: null,
};


export default function checkInSettings(state = initialState, action) {
    switch (action.type) {
        case GET_CHECK_IN_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            }
        case GET_CHECK_IN_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload.checkInSetting,
                loading: false,
                error: null,
                message: null,
            }
        case GET_CHECK_IN_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            }

        case UPDATE_CHECK_IN_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            }
        case UPDATE_CHECK_IN_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload.checkInSetting,
                loading: false,
                error: null,
                message: "Check-In settings has been saved successfully!",
            }
        case UPDATE_CHECK_IN_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            }

        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
            };
        }
        default:
            return {
                ...state,
            };
    }
}